import UxSection from './UxSection';
import CreativeSection from './CreativeSection';
import BrandingSection from './BrandingSection';
import FrontSection from './FrontSection';


const AllWorksSection = () => {
  return (
    <>
      <UxSection/>
      <CreativeSection/>
      <BrandingSection/>
      <FrontSection/>
    </>
  );
};

export default AllWorksSection;
